import { NumericInput } from '@/components/inputs/NumericInput'
import {
  FilterViewDivider,
  FilterViewHeader,
  FilterViewItem,
  FilterViewItemGroup,
} from '@/components/FilterControls'

interface NumberRangeFilterViewProps {
  title: string
  min?: number | null
  max?: number | null
  onMinChange: (value: number | null) => void
  onMaxChange: (value: number | null) => void
  onClear: () => void
  currencyCode: string
  unitName: string
  testId?: string
}

/**
 * Editor for a filter on a range of amounts.
 */
export function NumberRangeFilterView({
  title,
  min,
  max,
  onMinChange,
  onMaxChange,
  onClear,
  currencyCode,
  unitName,
  testId,
}: NumberRangeFilterViewProps) {
  return (
    <>
      <FilterViewHeader
        title={title}
        onClear={onClear}
        testId={testId && `${testId}-clear-button`}
      />
      <FilterViewItemGroup>
        <FilterViewItem title={`Min ${unitName}`}>
          <NumericInput
            currencyCode={currencyCode}
            precision={2}
            value={min}
            onChange={onMinChange}
            testId={testId && `${testId}-from-field`}
          />
        </FilterViewItem>
        <FilterViewDivider />
        <FilterViewItem title={`Max ${unitName}`}>
          <NumericInput
            currencyCode={currencyCode}
            precision={2}
            value={max}
            onChange={onMaxChange}
            testId={testId && `${testId}-to-field`}
          />
        </FilterViewItem>
      </FilterViewItemGroup>
    </>
  )
}
